import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CardsStore = {
  isLoading: boolean;
  errorMsg: string;
  fieldErrors: Record<string, string>;
  // clientAccounts: AccountPaymentInformation[] | null;
};

const initialState: CardsStore = {
  isLoading: false,
  errorMsg: '',
  fieldErrors: {}
  // clientAccounts: null
};

export const cardsSlice = createSlice({
  name: 'cards',
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.errorMsg = action.payload;
    },
    setFieldError: (
      state,
      action: PayloadAction<{ field: string; error: string }>
    ) => {
      state.fieldErrors[action.payload.field] = action.payload.error;
    },
    clearErrors: (state) => {
      state.errorMsg = '';
      state.fieldErrors = {};
    }
  }
});

export const { setIsLoading, setError, setFieldError, clearErrors } =
  cardsSlice.actions;

export default cardsSlice.reducer;
